@use "../../styles/breakpoint.module.scss" as *;

.dl {
    composes: listReset from "../../styles/composable/utility.module.css";
    container-type: inline-size;
}

.definitionGroup {
    display: flex;
    gap: var(--spacer-24);
    margin-block: var(--spacer-32);

    @container (width < 450px) {
        &:not(.featured) {
            flex-direction: column;
            gap: var(--spacer-4);
        }
    }
}

.featured {
    flex-direction: column;
    gap: var(--spacer-16);
    margin-bottom: var(--spacer-16);
    padding-block: var(--spacer-8) var(--spacer-40);
    border-bottom: 1px solid var(--white-gray);

    + * {
        padding-top: var(--spacer-8);
    }
}

.dt {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    flex: 0 0 200px;
    padding-top: 2.5px;
    font: var(--font-eyebrow);

    @media ($below-tablet) {
        padding-top: 4px;
    }

    @media ($below-tablet) and ($above-mobile) {
        font-size: 14px;
        padding-top: 0;
    }

    @container (width < 450px) {
        flex: 0 0 0;
        padding-top: 0;
    }

    .featured & {
        flex: 0 0 0;
        padding-top: 0;
    }
}

.ddGroup {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);

    .featured & {
        flex-flow: row wrap;
        width: 50%;
        min-width: 300px;

        @container (width < 450px) {
            width: 100%;
            min-width: 0;
        }
    }
}

.dd {
    width: 100%;

    .featured & {
        width: calc(100% - 13px - var(--spacer-8));
    }
}

.check {
    width: 13px;
    height: 10px;
    margin-top: 5px;
    fill: var(--gray);
}
